import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';
import PopoverButton from 'talent_matching/components/filters/popover_button';
import TagsDropdown from 'talent_search/components/dropdowns/tags_dropdown';
import { useRediscoveryTabContext } from 'talent_matching/contexts/rediscovery_tab_context';
import LastActivity from 'talent_search/components/dropdowns/last_activity';
import ReferralsCheckbox from 'talent_search/components/checkboxes/referrals_checkbox';
import Education from 'talent_search/shared/education';
import styled from 'styled-components';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row');

const ActivityWrapper = styled.div`
  & [data-provides='stack'] {
    flex-wrap: nowrap;
  }
  & [data-provides='stack'] > * {
    min-width: 0;
  }
  [data-provides='text-input'] {
    max-width: 213px;
  }
  .react-datepicker {
    min-width: unset;
  }
`;

const REDISCOVERY_PAGE_NAME = 'rediscovery' as const;

const CandidateFiltersGroup = () => {
  const { apiClient } = useRediscoveryTabContext();
  const { watch, setValue } = useFormContext();
  const [
    candidateTags,
    lastActivityStart,
    lastActivityEnd,
    referralsOnly,
    schools,
    degrees,
    disciplines,
  ] = watch([
    'candidate_tags',
    'last_activity_start',
    'last_activity_end',
    'referrals_only',
    'schools',
    'degrees',
    'disciplines',
  ]);

  const hasTags = Array.isArray(candidateTags) && candidateTags.length > 0;
  const hasReferrals = Boolean(referralsOnly);
  const activityCount =
    (lastActivityStart && String(lastActivityStart).trim() !== '' ? 1 : 0) +
    (lastActivityEnd && String(lastActivityEnd).trim() !== '' ? 1 : 0);
  const educationCount =
    (Array.isArray(schools) && schools.length > 0 ? 1 : 0) +
    (Array.isArray(degrees) && degrees.length > 0 ? 1 : 0) +
    (Array.isArray(disciplines) && disciplines.length > 0 ? 1 : 0);

  const appliedCount =
    (hasTags ? 1 : 0) + (hasReferrals ? 1 : 0) + activityCount + educationCount;

  const clear = () => {
    setValue('candidate_tags', [], { shouldDirty: true });
    setValue('last_activity_start', null, { shouldDirty: true });
    setValue('last_activity_end', null, { shouldDirty: true });
    setValue('referrals_only', false, { shouldDirty: true });
    setValue('schools', [], { shouldDirty: true });
    setValue('degrees', [], { shouldDirty: true });
    setValue('disciplines', [], { shouldDirty: true });
    setValue('show_education', false, { shouldDirty: true });
  };

  const buttonLabel = `${t('candidate_filters')}${
    appliedCount ? ` (${appliedCount})` : ''
  }`;

  return (
    <PopoverButton
      buttonLabel={buttonLabel}
      title={t('candidate_filters')}
      width="520px"
    >
      <Stack spacing={3}>
        <TagsDropdown apiClient={apiClient} pageName={REDISCOVERY_PAGE_NAME} />
        <ActivityWrapper>
          <LastActivity pageName={REDISCOVERY_PAGE_NAME} />
        </ActivityWrapper>
        <ReferralsCheckbox pageName={REDISCOVERY_PAGE_NAME} />
        <Education apiClient={apiClient} />
        <Stack sx={{ alignSelf: 'flex-start' }}>
          <TertiaryButton onClick={clear} size="lg">
            {t('clear')}
          </TertiaryButton>
        </Stack>
      </Stack>
    </PopoverButton>
  );
};

export default CandidateFiltersGroup;
